import { Injectable } from '@angular/core';
import { BaseApiService } from '../base.api.service';
import { Observable, throwError } from 'rxjs';
import { Auth } from '../../../../models/auth.model';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationAdapterService } from '../../../adapter/auth/authentication.adapter.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationApiService {
  constructor(private adapter: AuthenticationAdapterService, private baseGoApi: BaseApiService) {}

  private readonly _serviceType = 'auth/v1';

  public authenticate(credentials: {
    username: string;
    password: string;
    fcmToken?: string;
    dataKlinikUrl?: string;
    deviceInfo?: string;
  }): Observable<Auth> {
    return this.baseGoApi
      .post(
        {
          serviceType: this._serviceType,
          endpoint: 'authenticate',
        },
        {
          ...credentials,
          source: 'super-app',
        }
      )
      .pipe(
        map((data) => {
          if (!data) {
            return null;
          }
          return this.adapter.adapt(data);
        })
      );
  }

  public refreshToken(idLogin: number, refreshToken: string): Observable<{ token: string }> {
    return this.baseGoApi
      .post(
        { serviceType: this._serviceType, endpoint: 'refresh' },
        {
          id: idLogin,
          refreshToken,
        }
      )
      .pipe(
        map((data) => {
          if (!data) return null;
          return { token: data.token };
        })
      );
  }

  public signOut(refreshToken: string) {
    return this.baseGoApi
      .post(
        { serviceType: this._serviceType, endpoint: 'signout' },
        {
          refreshToken,
        }
      )
      .pipe(catchError((err) => throwError(err)));
  }
}
